export const PERFORMANCE_OVER_TIME_HELP_TEXT = "Performance over time which includes unresolved and resolved findings";
export const INVENTORY_OVER_TIME_HELP_TEXT = "Track AI inventory count trends over time by risk level or status";
export const AI_ACTIVITY_OVER_TIME_HELP_TEXT = "Track AI activity trends over time including usage and user counts";
